import ColumnMenu from '@components/Kendo/ColumnMenu';

export default ColumnMenu;
